module.exports = __webpack_public_path__ + "static/media/litter_icon.dacff5ee.svg";